/**
 * BOLD Subscription.
 * @see https://support.boldcommerce.com/hc/en-us/articles/360050564211-Manual-Installation-Guide-for-Subscriptions-for-Shopify-Checkout#manual-install-online-store-2.0-themes
 *
 */
(function() {
  var BsubWidget = (function () {
    function BsubWidget() {
      this.attrs = {
        sellingPlanIdInput: 'data-bsub-selling-plan-id-input',
        prepayCheckbox: 'data-bsub-prepay-checkbox',
        widget: 'data-bsub-widget',
        sellingPlanGroup: 'data-bsub-selling-plan-group',
        sellingPlanGroupInput: 'data-bsub-selling-plan-group-input',
        sellingPlanInput: 'data-bsub-selling-plan-input',
        collapsibleWrapper: 'data-bsub-collapsible-wrapper',
        subDetailsBtn: 'data-bsub-toggle-details-btn',
        autoRenewMethod: 'data-bsub-renewal-method',
        groupDiscountSummary: 'data-bsub-group-discount-summary',
        perDeliveryPrice: 'data-bsub-per-delivery-price',
        deliveryFrequencyOption: 'data-bsub-delivery-frequency-option',
        billingFrequencyOption: 'data-bsub-billing-frequency-option',
        productJson: 'data-bsub-product-json',
        blockSettingsJson: 'data-bsub-block-settings-json',
        moneyFormat: 'data-bsub-money-format',
        pageTemplate: 'data-bsub-page-template',
      }

      this.selectors = {
        productForm: 'form[action^="/cart/add"]',
        variantIdInput: '[name="id"]',
        deliveryFieldSet: '.bsub-widget__delivery-fieldset',
        planPricing: '.bsub-widget__plan-pricing',
        optionsContainer: '.bsub-options-container',
        optionContainer: '.bsub-option-container',
        billingFieldSet: '.bsub-widget__billing-fieldset',
        planMainText: '.bsub-widget__main-text',
        planSubText: '.bsub-widget__sub-text',
        renewalSubText: '.bsub-widget__renewal-text',
        recurringProductImage: '.bsub-widget__recurring-product-image',
        recurringProductFullPrice: '.bsub-widget__recurring-product-full-price',
        recurringProductDiscountedPrice: '.bsub-widget__recurring-product-discounted-price',
        recurringProductDiscountedText: '.bsub-widget__recurring-product-discounted-text',
        recurringProductName: '.bsub-widget__recurring-product-name',
        recurringVariantName: '.bsub-widget__recurring-variant-name',
        convertibleTextClassName: 'bsub__convertible-text',
        convertibleGroupIdInputClassName: 'bsub__convertible-group-id',
        convertiblesContainerOneTimePurchase: '.bsub-widget__convertibles-container-one-time-purchase',
        variantSelector: [
          '#shappify-variant-id',
          '.single-option-selector',
          'select[name=id]',
          'input[name=id]',
          'variant-selects select',
          'variant-radios input',
        ],
      };

      this.renewalMethods = {
        standard: 'Standard',
        prepaid: 'Prepaid',
        none: 'No renewal',
      }

      this.discountTypes = {
        noDiscount: 'no_discount',
        percentage: 'percentage',
        fixed: 'fixed',
      };

      // autogenerate selectors from attributes
      Object.entries(this.attrs).forEach(function ([key, value]) {
        this.selectors[key] = `[${value}]`;
      }.bind(this));

      this.classes = {
        hidden: 'bsub__hidden',
        collapsibleClosed: 'bsub__collapsible-wrapper--closed',
        subDetailsBtnClosed: 'bsub-widget__toggle-details-btn--closed'
      };

      this.products = {};
      this.variants = {};
      this.sellingPlanGroups = {};
      this.pageTemplate = '';
      this.recurringVariantName = '';
      this.convertibleAdjustmentGroupId = null;
    }

    BsubWidget.prototype = Object.assign({}, BsubWidget.prototype, {
      init: function () {
        console.debug('BSUB: Initializing widgets...');

        var widgets = document.querySelectorAll(this.selectors.widget);
        if (!widgets) {
          console.debug('BSUB: No widgets detected, skipping initialization.');
          return;
        }

        this._addSellingPlanInputToProductForm()
        this._parsePageTemplate();
        this._parseProductJson();
        this._parseBlockSettingsJson();
        this._addVariantChangeListener();

        widgets.forEach(function (widget) {
          this.handleSelectionChange(null, widget);
          this._renderDiscountSummaries(widget);
        }.bind(this));

        window.addEventListener("pageshow", function () {
          this.syncAllVisuallySelected();
        }.bind(this));

        console.debug('BSUB: Successfully initialized widgets.');
      },

      /**
       * _addSellingPlanInputToProductForm
       *
       * Add a hidden input to the product form so that the selected subscription will be added to the line item when the
       * product is added to the cart.
       *
       * @returns {undefined}
       */
      _addSellingPlanInputToProductForm: function () {
        var productForms = document.querySelectorAll(this.selectors.productForm);
        productForms.forEach(function (form) {
          var sellingPlanInput = document.createElement('input');
          sellingPlanInput.type = 'hidden';
          sellingPlanInput.name = 'selling_plan';
          sellingPlanInput.setAttribute(this.attrs.sellingPlanIdInput, "");

          form.appendChild(sellingPlanInput);
        }.bind(this));
      },

      /**
       * syncAllVisuallySelected
       *
       * Set the hidden selling_plan input to the visually selected plan in the widget.
       * The browser caches form state between back and forward navigations, but doesn't emit change events.
       *
       * @returns {undefined}
       */
      syncAllVisuallySelected: function () {
        var widgets = document.querySelectorAll(this.selectors.widget);
        widgets.forEach(this._syncVisuallySelected.bind(this));
      },

      _syncVisuallySelected: function (widget) {
        var selectedGroupEl = widget.querySelector(`${this.selectors.sellingPlanGroupInput}:checked`);
        selectedGroupEl.dispatchEvent(new Event('change'));
      },

      _addVariantChangeListener: function () {
        var productForm = document.querySelector(this.selectors.productForm);
        var variantIdInput = productForm.querySelector(this.selectors.variantIdInput)

        if (variantIdInput) {
          variantIdInput.addEventListener('change', function (event) {
            var widget = document.querySelector(this.selectors.widget);

            this.handleSelectionChange(null, widget);
            this._renderDiscountSummaries(widget);
          }.bind(this));
        }
      },

      /**
       * _parsePageTemplate
       *
       * Parse the page template input from the widget liquid. Used to determine what template the widget is being
       * rendered on (i.e. product, collection, cart, etc.)
       *
       * @returns {undefined}
       */
      _parsePageTemplate: function () {
        var pageTemplateInputEl = document.querySelector(this.selectors.pageTemplate);
        if (pageTemplateInputEl === null) {
          return;
        }
        this.pageTemplate = pageTemplateInputEl.value;
      },

      _parseBlockSettingsJson: function () {
        var element = document.querySelector(this.selectors.blockSettingsJson);

        if (element === null) {
          return;
        }

        this.blockSettings = JSON.parse(element.innerHTML);
      },

      _parseProductJson: function () {
        var productJsonElements = document.querySelectorAll(this.selectors.productJson);

        productJsonElements.forEach(function (element) {
          var productJson = JSON.parse(element.innerHTML);
          this.products[element.dataset.bsubProductId] = productJson;

          productJson.selling_plan_groups.forEach(function (sellingPlanGroup) {
            this.sellingPlanGroups[sellingPlanGroup.id] = sellingPlanGroup;
          }.bind(this));

          productJson.variants.forEach(function (variant) {
            this.variants[variant.id] = variant;
          }.bind(this));
        }.bind(this));
      },

      renderAllPrices: function () {
        var widgets = document.querySelectorAll(this.selectors.widget);
        widgets.forEach(function(widget) {
          this._renderPrices(widget);
        }.bind(this));
      },

      /**
       * _renderPrices
       *
       * Display "price / delivery" for each plan label.
       * Should run again if variant changes.
       *
       * @returns {undefined}
       */
      _renderPrices: function (widget, sellingPlan) {
        if (typeof widget === 'undefined') {
          widget = document.querySelector(this.selectors.widget);
        }

        var variantId = this._getVariantId(widget);
        if (!variantId) {
          return;
        }

        var selectedGroupId = this._getSelectedGroupId(widget);
        if (!selectedGroupId) {
          return;
        }

        var selectedDeliveryFrequency = widget.querySelector(`${this.selectors.deliveryFrequencyOption}:checked`).value
        var isPrepaid = this._isPrepaidSelected(widget);
        var isConvertible = sellingPlan.options.length === 2;
        var optionContainers = widget.querySelectorAll(this.selectors.optionContainer);

        optionContainers.forEach(function(container) {
          var value = container.dataset.bsubOption;
          var priceElement = container.querySelector(this.selectors.perDeliveryPrice)
          var allocation;

          if (container.dataset.bsubOptionDelivery) {
            if (isPrepaid || isConvertible) {
              priceElement.parentElement.classList.add(this.classes.hidden);
            } else {
              priceElement.parentElement.classList.remove(this.classes.hidden);
            }
            allocation = this._getVariantSellingPlanAllocation(variantId, selectedGroupId, [value]);
          } else {
            allocation = this._getVariantSellingPlanAllocation(variantId, selectedGroupId, [selectedDeliveryFrequency, value]);

            if (allocation) {
              container.querySelector(this.selectors.planSubText).innerHTML = this._applyMergeFields(
                this._getBlockSetting('prepaid_total_text'),
                { price: this._formatPrice(allocation.price) },
              );

              var method = !sellingPlan || sellingPlan.options.length < 3 ? this.renewalMethods.standard : sellingPlan.options[2].value;
              let prepaidTextSelector;

              switch (method) {
                case this.renewalMethods.prepaid:
                  prepaidTextSelector = 'prepaid_continue_as_prepaid_text';
                  break;
                case this.renewalMethods.standard:
                  prepaidTextSelector = "prepaid_continue_as_standard_text";
                  break;
                case this.renewalMethods.none:
                default:
                  prepaidTextSelector = null
                  break;
              }

              const renewalSubTextEl = container.querySelector(this.selectors.renewalSubText)
              renewalSubTextEl.innerHTML = '';

              if (prepaidTextSelector) {
                renewalSubTextEl.innerHTML = this._applyMergeFields(
                    this._getBlockSetting(prepaidTextSelector),
                    { count: container.dataset.bsubOption },
                  );
              }
            }
          }

          if (allocation) {
            priceElement.innerHTML = this._formatPrice(allocation.per_delivery_price);
          }
        }.bind(this));
      },

      renderAllGroupDiscountSummary: function () {
        var widgets = document.querySelectorAll(this.selectors.widget);
        widgets.forEach(function(widget) {
          this._renderDiscountSummaries(widget);
        }.bind(this));
      },

      _renderDiscountSummaries: function (widget) {
        var productJsonEl = widget.querySelector(this.selectors.productJson);
        var productId = productJsonEl.dataset.bsubProductId;
        var product = this.products[productId];

        var groupRadioEls = widget.querySelectorAll(this.selectors.sellingPlanGroup);
        groupRadioEls.forEach(function (element) {
          var groupId = element.dataset.bsubSellingPlanGroupId;
          var sellingPlanGroup = product.selling_plan_groups.find(function (group) {
            return group.id === groupId;
          });

          var summaryEl = element.querySelector(this.selectors.groupDiscountSummary);
          var discountText = this._getMaxDiscountText(sellingPlanGroup.selling_plans);

          if (!discountText) {
            summaryEl.classList.add(this.classes.hidden);
            return;
          }

          summaryEl.innerHTML = discountText

          if (sellingPlanGroup.options.length !== 3) {
            return;
          }

          var prepaidSummaryEl = widget.querySelector(`${this.selectors.optionsContainer}[data-bsub-selling-plan-group-id="${groupId}"] [data-bsub-prepaid-discount-summary]`);
          var prepaidDiscountText = this._getMaxDiscountText(sellingPlanGroup.selling_plans.filter(function (plan) {
            return plan.options[1].value !== '1';
          }));

          if (!prepaidDiscountText) {
            prepaidSummaryEl.classList.add(this.classes.hidden);
            return;
          }

          prepaidSummaryEl.innerHTML = prepaidDiscountText;
        }.bind(this));
      },

      _getMaxDiscountText: function (sellingPlans) {
        var discounts = sellingPlans.map(function (plan) {
          if (plan.price_adjustments.length === 0) {
            return {
              value: 0,
              type: ''
            };
          }

          return {
            value: plan.price_adjustments[0].value,
            type: plan.price_adjustments[0].value_type,
          };
        });

        if (discounts.length === 0) {
          return;
        }

        var maxDiscount = discounts.reduce(function (a, b) {
          return a.value > b.value ? a : b;
        });

        if (maxDiscount.value === 0) {
          return;
        }

        var plural = discounts.some(function (discount) {
          return discount.value !== maxDiscount.value;
        });

        var discount = `${maxDiscount.value}%`;
        if (maxDiscount.type === 'fixed_amount') {
          discount = this._formatPrice(maxDiscount.value);
        }

        if (plural) {
          return this._applyMergeFields(
            this._getBlockSetting('discount_summary_plural_text'),
            { discount: discount },
          );
        }

        return this._applyMergeFields(
          this._getBlockSetting('discount_summary_text'),
          { discount: discount },
        );
      },

      _hasMultipleDiscounts: function (sellingPlans) {
        var discounts = sellingPlans.map(function (plan) {
          if (plan.price_adjustments.length === 0) {
            return {
              value: 0,
              value_type: ''
            };
          }

          return {
            value: plan.price_adjustments[0].value,
            value_type: plan.price_adjustments[0].value_type,
          };
        });

        if (discounts.length === 0) {
          return false;
        }

        var plural = discounts.some(function (discount) {
          return discount.value !== discounts[0].value;
        });

        return plural;
      },

      _getDiscountText: function (discount) {
        if (discount.value === 0) {
          return;
        }

        var discountText = `${discount.value}%`;
        if (discount.value_type === 'fixed_amount') {
          discountText = this._formatPrice(discount.value);
        }

        return discountText
      },

      _applyDiscountToPrice: function(discountType, discountValue, originalPrice) {
        let discountedPrice;
        switch (discountType) {
          case this.discountTypes.noDiscount:
            discountedPrice = originalPrice;
            break;
          case this.discountTypes.percentage:
            discountedPrice = Math.round(originalPrice * (1 - discountValue/100) * 100) / 100;
            break;
          case this.discountTypes.fixed:
            discountedPrice = originalPrice - discountValue
            break;
          default:
            console.warn("attempted to apply discount with unknown discount type")
        }

        return discountedPrice
      },

      _buildDiscountedText: function(discountType, discountValue) {
        let discountedText = 'Save ';
        switch (discountType) {
          case this.discountTypes.noDiscount:
            return '';
          case this.discountTypes.percentage:
            discountedText += parseFloat((Math.round(discountValue * 100) / 100).toFixed(2)).toString(10) + "% after the first order";
            break;
          case this.discountTypes.fixed:
            discountedText += "$" + parseFloat((discountValue / 100).toFixed(2)).toString(10) + " after the first order"
            break;
          default:
            console.warn("attempted to apply discount with unknown discount type")
        }

        return discountedText
      },

      _getRecurringProductDiscountedPrice: function(recurringProductJson, recurringVariant) {
        const { discount } = recurringProductJson;
        const [discountType, discountValueStr] = discount.split('|')
        const discountValue = parseFloat(discountValueStr)

        return this._applyDiscountToPrice(discountType, discountValue, recurringVariant.price)
      },

      _setRecurringProductPrices: function(recurringProductJson, recurringVariant, sellingPlan) {
        const recurringProdFullPriceElems = document.querySelectorAll(this.selectors.recurringProductFullPrice);
        const recurringProdDiscountedTextElems = document.querySelectorAll(this.selectors.recurringProductDiscountedText);
        const recurringProdDiscountedPriceElems = document.querySelectorAll(this.selectors.recurringProductDiscountedPrice);

        const { discount } = recurringProductJson;
        const [discountType, discountValueStr] = discount.split('|')
        const discountValue = parseFloat(discountValueStr)

        let priceAdjustmentDiscountType, priceAdjustmentDiscountValue
        if (sellingPlan.price_adjustments.length > 0) {
          if (sellingPlan.price_adjustments[0].value_type === 'percentage') {
            priceAdjustmentDiscountType = this.discountTypes.percentage;
            priceAdjustmentDiscountValue =  sellingPlan.price_adjustments[0].value;
          }
          if (sellingPlan.price_adjustments[0].value_type === "fixed_amount") {
            priceAdjustmentDiscountType = this.discountTypes.fixed;
            priceAdjustmentDiscountValue = sellingPlan.price_adjustments[0].value * 100;
          }
        }

        const discountedPrice = this._getRecurringProductDiscountedPrice(recurringProductJson, recurringVariant)

        if (discountedPrice < recurringVariant.price) {
          const discountedText = this._buildDiscountedText(discountType, discountValue)
          // don't display the discount text if the discount is the same as the initial order
          if (!priceAdjustmentDiscountType || priceAdjustmentDiscountType !== discountType || priceAdjustmentDiscountValue !== discountValue) {
            recurringProdDiscountedTextElems.forEach((elem) => {
              elem.classList.remove(this.classes.hidden);
              elem.innerHTML = discountedText;
            })
          } else {
            recurringProdDiscountedTextElems.forEach((elem) => {
              elem.classList.add(this.classes.hidden);
            })
          }
          recurringProdFullPriceElems.forEach((elem) => {
            elem.innerHTML = this._formatPrice(recurringVariant.price);
          });
        } else {
          // don't display the discount text if there is no discount
          recurringProdDiscountedTextElems.forEach((elem) => {
            elem.classList.add(this.classes.hidden);
          })
          recurringProdFullPriceElems.forEach((elem) => {
            elem.classList.add(this.classes.hidden);
          })
        }

        recurringProdDiscountedPriceElems.forEach((elem) => {
          elem.innerHTML = this._formatPrice(discountedPrice);
        });
      },

      _setRecurringProductInfo: async function (sellingPlan) {
        const {products: recurringProducts, key: groupId} = JSON.parse(sellingPlan.options[1].value);
        const recurringProductJson = recurringProducts[0];

        const response = await fetch(`${window.Shopify.routes.root}products/${recurringProductJson['handle']}.js`);
        const product = await response.json();

        const recurringProdImageElems = document.querySelectorAll(this.selectors.recurringProductImage);
        const recurringProdNameElems = document.querySelectorAll(this.selectors.recurringProductName);
        const recurringVarNameElems = document.querySelectorAll(this.selectors.recurringVariantName);
        const recurringVariant = product['variants'].find((variant) =>
          variant.id === parseInt(recurringProductJson['variant_id']));

        recurringProdImageElems.forEach((elem) => {
          elem.src = recurringVariant.featured_image !== null ?
            recurringVariant.featured_image.src : product.featured_image;
        });

        recurringProdNameElems.forEach((elem) => {
          elem.innerHTML = product.title;
        });

        if (recurringVariant.title !== 'Default Title') {
          recurringVarNameElems.forEach((elem) => {
            elem.innerHTML = `(${recurringVariant.title})`;
          });
        }

        this._setRecurringProductPrices(recurringProductJson, recurringVariant, sellingPlan);
        this.recurringVariantName = recurringVariant.name;
        this.convertibleAdjustmentGroupId = groupId;
        this._addConvertibleInputsToForms(recurringProductJson, recurringVariant);
      },

      handleSelectionChange: function (event, widget) {
        if (typeof widget === 'undefined') {
          widget = event.target.closest(this.selectors.widget);
        }


        var selectedGroupId = this._getSelectedGroupId(widget);
        var variantId = this._getVariantId(widget);
        var optionsContainers = widget.querySelectorAll(this.selectors.optionsContainer);
        const convertiblesContainerOneTimePurchase = widget.querySelector(this.selectors.convertiblesContainerOneTimePurchase);
        const RECURRING_PRODUCT_POSITION = 2;

        if (this.variants[variantId].selling_plan_allocations.length > 0) {
          widget.classList.remove(this.classes.hidden);
        } else {
          widget.classList.add(this.classes.hidden);
        }


        if (selectedGroupId === 'once') {
          optionsContainers.forEach(function (container) {
            container.classList.add(this.classes.hidden);
          }.bind(this));

          if (this.recurringVariantName) {
            convertiblesContainerOneTimePurchase.classList.remove(this.classes.hidden);
          }

          this._setSellingPlanIdInput(widget, "");

          return;
        }

        if (this.recurringVariantName) {
          convertiblesContainerOneTimePurchase.classList.add(this.classes.hidden);
        }
        var optionContainer;
        optionsContainers.forEach(function (container) {
          var groupId = container.dataset.bsubSellingPlanGroupId;

          if (groupId == selectedGroupId) {
            optionContainer = container;
            container.classList.remove(this.classes.hidden);
          } else {
            container.classList.add(this.classes.hidden);
          }
        }.bind(this))

        var selectedDeliveryFrequency = optionContainer.querySelector(`${this.selectors.deliveryFrequencyOption}:checked`);
        if (!selectedDeliveryFrequency) {
          selectedDeliveryFrequency = optionContainer.querySelector(this.selectors.deliveryFrequencyOption);
          selectedDeliveryFrequency.checked = true
        }

        var prepaidFieldSet = optionContainer.querySelector(this.selectors.billingFieldSet)

        var sellingPlans = this._getSellingPlanGroup(selectedGroupId).selling_plans;

        var deliveryFrequencyContainers = optionContainer.querySelectorAll(`${this.selectors.optionContainer}[data-bsub-option-delivery]`);
        deliveryFrequencyContainers.forEach(function (container) {
          var mainText = container.dataset.bsubOption;

          var discountText;
          sellingPlans.forEach(function (sellingPlan) {

              // Used to hide frequencies when the current variant doesn't have the current selling plan we are looping through attached to it.
              let isSellingPlanInAllocations = this.variants[variantId].selling_plan_allocations.some(allocation => allocation.selling_plan_id === sellingPlan.id);

            if (sellingPlan.name === container.dataset.bsubOption) {
              if (isSellingPlanInAllocations) {
                container.classList.remove(this.classes.hidden);

                if (sellingPlan.price_adjustments.length > 0) {
                  discountText = this._applyMergeFields(
                    this._getBlockSetting('delivery_frequency_discount_text'),
                    {discount: this._getDiscountText(sellingPlan.price_adjustments[0])},
                  )
                }
              } else {
                container.classList.add(this.classes.hidden);
              }
            }
          }.bind(this));

          if (discountText && this._hasMultipleDiscounts(sellingPlans)) {
            mainText = mainText + ' ' + discountText
          }

          container.querySelector(this.selectors.planMainText).innerHTML = mainText;
        }.bind(this))


        // Ensure the selected delivery frequency is set to the first visible (not hidden) option
        var firstVisibleDeliveryFrequency = Array.from(optionContainer.querySelectorAll(this.selectors.deliveryFrequencyOption)).find(option => !option.closest(this.selectors.optionContainer).classList.contains(this.classes.hidden));
        if (!selectedDeliveryFrequency || selectedDeliveryFrequency.closest(this.selectors.optionContainer).classList.contains(this.classes.hidden)) {
          if (firstVisibleDeliveryFrequency) {
            firstVisibleDeliveryFrequency.checked = true;
            selectedDeliveryFrequency = firstVisibleDeliveryFrequency;
          }
        }

        if (!this._isPrepaidSelected(widget)) {
          if (prepaidFieldSet) {
            prepaidFieldSet.classList.add(this.classes.hidden);
          }

          var sellingPlan = this._getSellingPlanFromOptions(selectedGroupId, [selectedDeliveryFrequency.value]);

          this._setRenewalMethod(widget, sellingPlan);
          this._setSellingPlanIdInput(widget, sellingPlan.id);
          this._renderPrices(widget, sellingPlan);

          if (sellingPlan.options.length === RECURRING_PRODUCT_POSITION) {
            if (!this.recurringVariantName) {
              this._setRecurringProductInfo(sellingPlan);
            }
          } else {
            this._removeConvertibleInputsFromForms();
          }
          return;
        }

        var billingFrequencyContainers = optionContainer.querySelectorAll(`${this.selectors.optionContainer}[data-bsub-option-billing]`);
        var firstVisibleBillingFrequencyContainer;
        var selectedBillingFrequency;
        billingFrequencyContainers.forEach(function (container) {
          var mainText = this._applyMergeFields(
            this._getBlockSetting('billing_frequency_text'),
            { count: container.dataset.bsubOption },
          )

          var discountText;
          sellingPlans.forEach(function (sellingPlan) {
            if (sellingPlan.options[1].value === container.dataset.bsubOption){
              if (sellingPlan.price_adjustments.length > 0) {
                discountText = this._applyMergeFields(
                  this._getBlockSetting('billing_frequency_discount_text'),
                  { discount: this._getDiscountText(sellingPlan.price_adjustments[0]) },
                )
              }
            }
          }.bind(this));

          if (discountText && this._hasMultipleDiscounts(sellingPlans)) {
            mainText = mainText + ' ' + discountText
          }

          container.querySelector(this.selectors.planMainText).innerHTML = mainText;

          var allocation = this._getVariantSellingPlanAllocation(variantId, selectedGroupId, [selectedDeliveryFrequency.value, container.dataset.bsubOption]);
          if (allocation) {
            container.classList.remove(this.classes.hidden);
            var selected = container.querySelector(`${this.selectors.billingFrequencyOption}:checked`);
            if (selected) {
              selectedBillingFrequency = selected;
            }
            if (!firstVisibleBillingFrequencyContainer) {
              firstVisibleBillingFrequencyContainer = container;
            }
          } else {
            container.classList.add(this.classes.hidden);
          }
        }.bind(this));

        prepaidFieldSet.classList.remove(this.classes.hidden);

        if (!selectedBillingFrequency) {
          selectedBillingFrequency = firstVisibleBillingFrequencyContainer.querySelector(this.selectors.billingFrequencyOption);
          selectedBillingFrequency.checked = true;
        }

        var sellingPlan = this._getSellingPlanFromOptions(selectedGroupId, [selectedDeliveryFrequency.value, selectedBillingFrequency.value]);

        this._setRenewalMethod(widget, sellingPlan);
        this._setSellingPlanIdInput(widget, sellingPlan.id);
        this._renderPrices(widget, sellingPlan);

        return
      },

      _getSelectedGroupId: function(widget) {
        var selectedGroupEl = widget.querySelector(`${this.selectors.sellingPlanGroupInput}:checked`);

        if (!selectedGroupEl) {
          return null;
        }

        return selectedGroupEl.value;
      },

      _isPrepaidSelected: function(widget) {
        var prepayCheckbox = widget.querySelector(this.selectors.prepayCheckbox);

        return prepayCheckbox && prepayCheckbox.checked;
      },

      _addPrepaidRenewalTextInputToForm: function (forms, text) {
        forms.forEach(function (form) {
          var renewalTextInput = document.createElement('input');
          renewalTextInput.type = 'hidden';
          renewalTextInput.id = 'renewalText'
          renewalTextInput.name = 'properties[Prepaid Renewal Method]';
          renewalTextInput.value = text;

          form.appendChild(renewalTextInput);
        }.bind(this));
      },

      _addConvertibleInputsToForms: function (recurringProductJson, recurringVariant) {
        const productForms = document.querySelectorAll(this.selectors.productForm);
        const discountedPrice = this._getRecurringProductDiscountedPrice(recurringProductJson, recurringVariant);
        const convertsToText = `${this.recurringVariantName} - ${this._formatPrice(discountedPrice)} after the first order`

        productForms.forEach(function (productForm) {

          const convertiblesTextInput = document.createElement('input');
          convertiblesTextInput.type = 'hidden';
          convertiblesTextInput.className = this.selectors.convertibleTextClassName;
          convertiblesTextInput.name = 'properties[Converts to]';
          convertiblesTextInput.value = convertsToText;

          productForm.appendChild(convertiblesTextInput);

          const convertibleGroupInput = document.createElement('input');
          convertibleGroupInput.type = 'hidden';
          convertibleGroupInput.className = this.selectors.convertibleGroupIdInputClassName;
          convertibleGroupInput.name = 'properties[_bold_convertible_adjustment_group_id]';
          convertibleGroupInput.value = this.convertibleAdjustmentGroupId;

          productForm.appendChild(convertibleGroupInput)
        }.bind(this));
      },

      _removeConvertibleInputsFromForms: function () {
        const productForms = document.querySelectorAll(this.selectors.productForm);

        productForms.forEach((productForm) => {
          const textInput = productForm.querySelector(`.${this.selectors.convertibleTextClassName}`);
          if (textInput) {
            textInput.parentElement.removeChild(textInput);
          }
          const groupInput = productForm.querySelector(`.${this.selectors.convertibleGroupIdInputClassName}`);
          if (groupInput) {
            groupInput.parentElement.removeChild(groupInput);
          }
        });
      },

      _removePrepaidRenewalTextInputFromForm: function (forms) {
        forms.forEach(function (form) {
          var renewalTextInput = document.querySelector('#renewalText');
          if (renewalTextInput) {
            form.removeChild(renewalTextInput);
          }
        }.bind(this));
      },

      _setPrepaidRenewalTextOnProductForm: function (text) {
        var productForms = document.querySelectorAll(this.selectors.productForm);
        this._removePrepaidRenewalTextInputFromForm(productForms)
        if (text) {
          this._addPrepaidRenewalTextInputToForm(productForms, text)
        }
      },

      _setRenewalMethod: function(widget, sellingPlan) {
        var autoRenewElement = widget.querySelector(this.selectors.autoRenewMethod);
        var method = sellingPlan.options.length < 3 ? this.renewalMethods.standard : sellingPlan.options[2].value;
        var renewalTextShort;
        var renewalText;

        switch (method) {
          case this.renewalMethods.prepaid:
            renewalTextShort = `auto-renews every ${sellingPlan.options[1].value} orders.`;
            renewalText = 'This charge will recur as a prepaid subscription after the last shipment';
            break;
          case this.renewalMethods.none:
            renewalTextShort = "does not auto-renew.";
            renewalText = 'This charge will end after the last shipment'
            break;
          case this.renewalMethods.standard:
            if (sellingPlan.options.length < 3 || sellingPlan.options[1].value === "1") {
              renewalTextShort = "auto-renews. It can be skipped or cancelled at anytime.";
            } else {
              renewalTextShort = `auto-renews ${sellingPlan.options[0].value} after ${sellingPlan.options[1].value} orders.`.toLowerCase();
              renewalText = 'This charge will recur as a regular subscription after the last shipment'
            }
            break;
        }

        this._setPrepaidRenewalTextOnProductForm(renewalText);
        autoRenewElement.innerText = renewalTextShort;
      },

      handleToggleSubDetails: function(event) {
        var widget = event.target.closest(this.selectors.widget);

        var collapsibleEl = widget.querySelector(this.selectors.collapsibleWrapper);
        var button = widget.querySelector(this.selectors.subDetailsBtn);

        button.classList.toggle(this.classes.subDetailsBtnClosed);
        collapsibleEl.classList.toggle(this.classes.collapsibleClosed);
      },

      _setSellingPlanIdInput: function (widget, sellingPlanId) {
        var productForms = document.querySelectorAll(this.selectors.productForm)

        productForms.forEach(function(form) {
          var sellingPlanIdInput = form.querySelector(this.selectors.sellingPlanIdInput);
          sellingPlanIdInput.value = sellingPlanId;
        }.bind(this));

        if (/.*(product).*/.test(this.pageTemplate)) {
          var variantId = this._getVariantId(widget);
          this._updateHistoryState(variantId, sellingPlanId);
        }
      },

      _getSellingPlanGroup: function (groupId) {
        if (!this.sellingPlanGroups[groupId]) {
          console.error('BSUB: Selling plan group data not found.');
          return;
        }

        return this.sellingPlanGroups[groupId];
      },

      _getSellingPlanFromOptions: function (groupId, options) {
        var sellingPlans = this._getSellingPlanGroup(groupId).selling_plans;

        var planFromOptions = sellingPlans.find(function (plan) {
          return options.every(function (option, i) {
            if (plan.options[i]) {
              return plan.options[i].value === option;
            }
          });
        });

        return planFromOptions;
      },

      /**
       * _getVariantId
       *
       * Return the Variant ID from the product form the widget is in.
       *
       * NOTE: The App Block version of the Subs widget assumes there's only a single instance of a product form on the
       * page. This could change in the future if we support collections pages.
       *
       * @param {Element} widget
       * @returns {string}
       */
      _getVariantId: function (widget) {
        var productForm = document.querySelector(this.selectors.productForm);
        if (!productForm) {
          console.error('BSUB, _getVariantId: Could not find product form.');
          return null;
        }
        var variantIdInput = productForm.querySelector(this.selectors.variantIdInput);

        return variantIdInput.value;
      },

      /**
       * _updateHistoryState
       *
       * Update the URL with the currently selected variant and selling plan IDs if applicable.
       *
       * @returns {undefined}
       */
      _updateHistoryState: function (variantId, sellingPlanId) {
        if (!history.replaceState || !variantId) {
          return;
        }

        var newUrl = new URL(window.location.href);
        var searchParams = newUrl.searchParams;

        if (sellingPlanId) {
          searchParams.set('selling_plan', sellingPlanId);
        } else if (newUrl.searchParams.has('selling_plan')) {
          searchParams.delete('selling_plan')
        }

        searchParams.set('variant', variantId);

        window.history.replaceState({
          path: newUrl.toString()
        }, '', newUrl.toString());
      },

      /**
       * _getSellingPlanAllocation
       *
       * SellingPlanAllocation is the the information of how a selling plan applies to a
       * specific variant (e.g. compare at price, price/delivery).
       *
       * @returns {undefined}
       */
      _getSellingPlanAllocation(variantId, sellingPlanId) {
        var variant = this.variants[variantId];

        if (!variant) {
          console.error(`BSUB: Could not find variant ID ${variantId}`);
          return null;
        }

        return variant.selling_plan_allocations.find(function (plan) {
          return `${plan.selling_plan_id}` === `${sellingPlanId}`;
        });
      },

      _getVariantSellingPlanAllocation(variantId, groupId, options) {
        var sellingPlan = this._getSellingPlanFromOptions(groupId, options);

        if (!sellingPlan) {
          return null;
        }

        return this._getSellingPlanAllocation(variantId, sellingPlan.id);
      },

      _formatPrice(cents, format) {
        var moneyElement = document.querySelector(this.selectors.moneyFormat)
        var moneyFormat = moneyElement ? moneyElement.getAttribute('data-bsub-money-format') : null

        if (typeof cents === 'string') {
          cents = cents.replace('.', '');
        }

        var value = '';
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var themeMoneyFormat = this._getThemeMoneyFormat();

        var formatString = format || moneyFormat || themeMoneyFormat;

        function formatWithDelimiters(number, precision, thousands, decimal) {
          thousands = thousands || ',';
          decimal = decimal || '.';

          if (isNaN(number) || number === null) {
            return 0;
          }

          number = (number / 100.0).toFixed(precision);

          var parts = number.split('.');
          var dollarsAmount = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            '$1' + thousands
          );
          var centsAmount = parts[1] ? decimal + parts[1] : '';

          return dollarsAmount + centsAmount;
        }

        switch (formatString.match(placeholderRegex)[1]) {
          case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
          case 'amount_no_decimals_with_space_separator':
            value = formatWithDelimiters(cents, 0, ' ');
            break;
          case 'amount_with_apostrophe_separator':
            value = formatWithDelimiters(cents, 2, "'");
            break;
        }

        return formatString.replace(placeholderRegex, value);
      },

      _getThemeMoneyFormat() {
        if (typeof Shopify !== 'undefined' && typeof Shopify.money_format !== 'undefined') {
          return Shopify.money_format;
        }

        if (typeof theme !== 'undefined') {
          if (typeof theme.moneyFormat !== 'undefined') {
            return theme.moneyFormat;
          }
          if (typeof theme.strings !== 'undefined' && typeof theme.strings.moneyFormat !== 'undefined') {
            return theme.strings.moneyFormat
          }
          if (typeof theme.shop !== 'undefined' && typeof theme.shop.money_format !== 'undefined') {
            return theme.shop.money_format;
          }
        }

        return "${{ amount }}";
      },

      _getBlockSetting: function (settingName) {
        if (!this.blockSettings) {
          return null;
        }

        return this.blockSettings[settingName];
      },

      _applyMergeFields: function (string, mergeFields) {
        return string.replace(/\{(\w+)\}/g, function(match, key) {
          return mergeFields.hasOwnProperty(key) ? mergeFields[key] : match;
        });
      }
    })

    return BsubWidget;
  })();

  document.addEventListener('DOMContentLoaded', function () {
    window.BOLD = window.BOLD || {};
    window.BOLD.BsubWidget = new BsubWidget();
    window.BOLD.BsubWidget.init();
  });

})()
